import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Stack, Typography } from '@mui/material';
import { Container } from '../../components/container';
import { FeedSettingsTable } from './components/feed-settings-table';
import { LoadingView } from '../../components/loading-view';
export const Settings = () => {
    return (_jsx(Container, { children: _jsxs(Stack, { paddingY: 4, spacing: 3, children: [_jsx(Typography, { variant: "h5", children: "Settings" }), _jsx(Suspense, { fallback: _jsx(LoadingView, { height: "100%" }), children: _jsx(FeedSettingsTable, {}) })] }) }));
};
